import type { InputHTMLAttributes } from 'react';
import styles from './style.module.css';

type Props = InputHTMLAttributes<HTMLInputElement> & {
  label: string;
  hint?: string;
};

export function TextInput({ label, hint, className, ...rest }: Props) {
  return (
    <label className={`${styles.field}${className ? ` ${className}` : ''}`}>
      <span className={styles.label}>
        {label}
        {hint && <span className={styles.hint}> {hint}</span>}
      </span>
      <input className={styles.input} {...rest} />
    </label>
  );
}
